import React from 'react';
import { palette } from '../../styles/theme';

export function RefreshSVG ({ customStroke = palette.secondary[600], className = '', selected = false }) {
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_6718_5761)">
                    <path d="M20 10.9997C19.7554 9.23992 18.9391 7.60937 17.6766 6.3592C16.4142 5.10904 14.7758 4.30862 13.0137 4.08126C11.2516 3.85389 9.46362 4.21219 7.9252 5.10095C6.38678 5.98972 5.18325 7.35964 4.5 8.99971M4 4.99971V8.99971H8" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 13C4.24456 14.7598 5.06093 16.3903 6.32336 17.6405C7.58579 18.8907 9.22424 19.6911 10.9863 19.9184C12.7484 20.1458 14.5364 19.7875 16.0748 18.8988C17.6132 18.01 18.8168 16.6401 19.5 15M20 19V15H16" stroke={customStroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_6718_5761">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
